const libForm = {
	EnterTab: (event) => {
		try {
			if (event.key === "Enter") {
				event.preventDefault();

				const currentField = event.target;
				const form = currentField.form;
				const fields = form.elements;

				// Encontrar o índice do campo atual
				const currentIndex = Array.from(fields).indexOf(currentField);

				// Encontrar o próximo campo
				const nextField = fields[currentIndex + 1] || fields[0];
				// Mover o foco para o próximo campo

				nextField.focus();
			}
		} catch (error) {}
	},
};

export default libForm;
